<template>
  <el-card>
    <el-form class="global-form2" label-width="100px" label-position="right">
      <el-form-item required label="巡查对象：" prop="elementName">
        <p>{{ detail.elementName || '' }}</p>
      </el-form-item>
      <el-form-item label="风险分级：" prop="riskLevel">
        <p>{{ detail.riskLevelName || '' }}</p>
      </el-form-item>
      <el-form-item required label="检查标准：" prop="standardList">
        <el-table class="global-table" :data="detail.standardList || []">
          <el-table-column label="内容" show-overflow-tooltip prop="standardContent"></el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="巡查频次：" prop="corpFrequency">
        <p>管理抽查&nbsp;{{ detail.corpFrequency || '' }}次/{{ [1, 2, 3].includes(detail.corpFrequencyType) ?
          cycleList[detail.corpFrequencyType - 1] : '日' }}</p>
        <p>项目自查&nbsp;{{ detail.cooperateFrequency || '' }}次/{{ [1, 2, 3].includes(detail.cooperateFrequencyType) ?
          cycleList[detail.cooperateFrequencyType - 1] : '日' }}</p>
      </el-form-item>
      <el-form-item label="管控措施：" prop="controlMeasures">
        <p>{{ detail.controlMeasures || '' }}</p>
      </el-form-item>
      <el-form-item label="应急处置：" prop="emergencyDisposal">
        <p>{{ detail.emergencyDisposal || '' }}</p>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>

export default {
  name: 'ElementDetailPage',
  data () {
    return {
      cycleList: ['日', '周', '月'],
      detail: {
        elementName: '',
        riskLevelName: '',
        standardList: [],
        corpFrequency: 0,
        corpFrequencyType: 1,
        cooperateFrequency: 0,
        cooperateFrequencyType: 1,
        controlMeasures: '',
        emergencyDisposal: ''
      }
    }
  },
  computed: {
    elementId () {
      return this.$route.params.elementId
    }
  },

  created () {
    this.loadData()
  },
  methods: {

    loadData () {
      this.$axios.get(this.$apis.patrol.selectElementByElementId, {
        elementId: this.elementId
      }).then(res => {
        this.detail = res || {}
      })
    }
  }

}
</script>

<style scoped lang="scss">
.global-table {
  margin-top: -13px;
}
</style>
